import React, { useEffect, useState } from 'react'
import { ClientService } from '../../component/services/client.service';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUniversity } from '@fortawesome/free-solid-svg-icons';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import Select from "react-select"
import CetLoader from '../../component/Loader/CetLoader';
import ReverificationTable from '../../component/table/Reverification.table';
import TablePaginationComponent from '../../component/table/TablePagination';
import moment from 'moment';
import { CSVLink } from "react-csv";
import downloadjs from "downloadjs"

export default function ReverificationsDetails() {
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(10);
    const [total, setTotal] = useState<number>(0);
    const [streams, setStreams] = useState<any>([]);
    const [selectedStreams, setSelectedStreams] = useState<any>();
    const [reverificationUsers, setReverificationsUsers] = useState<any>();
    const [selectedCollege, setSelectedCollege] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [colleges, setColleges] = useState<any[]>([]);
    const [csvLoading, setCsvLoading] = useState<boolean>(false);
    const [csvData, setCsvData] = useState<any>([]);

    const getAllUsersReverifications = async () => {
        setLoading(true);
        await ClientService.getAllUsersReverifications(pageNumber, pageSize, selectedCollege, selectedStreams).then((res) => {
            if (res.status === 200) {
                setReverificationsUsers(res.data.data?.reverifications);
                setTotal(res.data.data?.count);
            }
        }).catch((err) => {
            console.log(err)
            setLoading(false)
        }).finally(() => {
            setLoading(false)
        })
    }

    console.log(reverificationUsers, "users")

    const downloadReverificationCSV = async () => {
        setCsvLoading(true);
        try {
            const res = await ClientService.downloadReverificationCSV(selectedCollege, selectedStreams);

            if (res.status === 200) {
                // downloadjs(res.data, "")
                downloadjs(res.data, "reverification.csv");
                // setCsvData(
                //     res.data.data?.reverifications?.map((item: any, index: number) => {
                //         return {
                //             "Sr. No": index + 1,
                //             "CET Application No": item?.studentId?.reVerification_meta?.["CET Application No"] || "--",
                //             "CAP Application ID": item?.studentId?.reVerification_meta?.["CAP Application ID"] || "--",
                //             "Candidate Name": item?.studentId?.name || "--",
                //             "Institute Code": item?.studentId?.reVerification_meta?.["Alloted Institute Code"] || "--",
                //             "Institute Name": item?.studentId?.reVerification_meta?.["Alloted Institute Name"] || "--",
                //             "Stream": item?.studentId?.reVerification_meta?.["Stream"] || "--",
                //             "Verification Status": item?.success ? "Success" : "Not-Success",
                //             "Verification Time": moment(item?.updatedAt).format("DD-MM-YYYY, hh:mm A"),
                //         };
                //     })
                // );
            }
        } catch (err) {
            console.log(err);
        } finally {
            setCsvLoading(false);
        }
    };

    const getAllStreams = async () => {
        await ClientService.getAllStreams().then((res) => {
            if (res.status === 200) {
                setStreams(res.data.streams.map((data: any) => {
                    return {
                        label: data,
                        value: data
                    }
                }))
            }
        })
    }

    async function fetchColleges() {
        setLoading(true);
        await ClientService.getReverificationColleges()
            .then((res: any) => {
                if (res.status === 200) {
                    const collegeOptions = res.data?.data?.map((college: any) => ({
                        value: college?.collegId,
                        label: college?.collegeName
                    })) || [];
                    setColleges(collegeOptions);
                } else {
                    console.error("Failed to fetch colleges:", res);
                }
            })
            .catch((error: any) => {
                console.error("Error fetching colleges:", error);
            })
            .finally(() => {
                setLoading(false);
            });
    }

    useEffect(() => {
        if (selectedCollege || selectedStreams) {
            getAllUsersReverifications();
        }
    }, [selectedCollege, pageNumber, pageSize, selectedStreams])

    useEffect(() => {
        fetchColleges();
        getAllStreams();
    }, []);

    return (
        <Card className="mt-4 mb-5 shadow" style={{ borderRadius: "16px", border: "1px solid #e9ecef" }}>
            <Card.Body className="p-4">
                <Card
                    className="mt-3 mb-3"
                    style={{
                        backgroundColor: "#f9f9f9",
                        borderRadius: "12px",
                        border: "none",
                    }}
                >
                    <Card.Body>
                        <div className="d-flex align-items-center gap-3">
                            <div>
                                <Form.Label className="text-muted fw-bold">Select College</Form.Label>
                                <Select
                                    options={colleges}
                                    placeholder="Select College"
                                    onChange={(e: any) => setSelectedCollege(e?.value)}
                                    isClearable
                                    value={selectedCollege ? colleges.find((college: any) => college.value === selectedCollege.value) : null}
                                />
                            </div>
                            <div>
                                <Form.Label className="text-muted fw-bold">Select Stream</Form.Label>
                                <Select
                                    options={streams}
                                    placeholder="Select Stream"
                                    onChange={(e: any) => setSelectedStreams(e?.value)}
                                    isClearable
                                    value={selectedStreams ? streams?.find((streams: any) => streams.value === selectedStreams) : null}
                                />
                            </div>
                        </div>
                    </Card.Body>
                </Card>
                <div className="d-flex justify-content-between align-items-center mt-3">
                    <div>
                        <h5 className="text-secondary fw-bold mb-3" style={{ fontSize: '18px' }}>
                            Reverifications
                        </h5>
                    </div>
                    <div>
                        {/* {csvData && csvData.length > 0 ? (
                            <CSVLink
                                data={csvData}
                                filename={`Reverifications.csv`}
                                className="btn btn-sm btn-primary"
                                onClick={downloadReverificationCSV}
                            >
                                {csvLoading ? "Preparing..." : "Ready to Download CSV"}
                            </CSVLink>
                        ) : (
                            <Button onClick={downloadReverificationCSV} size="sm" disabled={csvLoading}>
                                {csvLoading ? "Preparing..." : "Download CSV"}
                            </Button>
                        )} */}
                        <Button onClick={downloadReverificationCSV} size="sm" disabled={csvLoading}>
                            {csvLoading ? "Preparing..." : "Download CSV"}
                        </Button>
                    </div>
                </div>

                {loading ? (
                    <div className="mt-4">
                        <CetLoader />
                    </div>
                ) : selectedCollege || selectedStreams ? (
                    <>
                        {/* <Card className="mt-4 shadow" style={{ borderRadius: "16px", border: "1px solid #e9ecef" }}>
                            <Card.Body className="p-4"> */}
                        <Row className="g-3">
                            <ReverificationTable tableData={reverificationUsers} />
                            <div>
                                <TablePaginationComponent
                                    currentPage={pageNumber}
                                    itemsCount={total}
                                    itemsPerPage={pageSize}
                                    setItemsPerPage={(e: any) => setPageSize(e)}
                                    setCurrentPage={setPageNumber}
                                />
                            </div>
                        </Row>
                        {/* </Card.Body>
                        </Card> */}
                    </>
                ) : selectedCollege ? (
                    <NoDataView message="No data available for the selected college." />
                ) : (
                    <div>
                        {loading ? <div>Loading...</div> :
                            <NoDataView message="Please select a college to view data." />
                        }
                    </div>
                )}
            </Card.Body>
        </Card>
    )
}

const NoDataView = ({ message }: { message: string }) => {
    return (
        <div className="text-center py-5">
            <div className="mb-3">
                <FontAwesomeIcon
                    icon={faUniversity}
                    className="text-muted"
                    style={{ fontSize: '48px', opacity: 0.3 }}
                />
            </div>
            <div className="text-muted" style={{ fontSize: '16px' }}>
                {message || "No college data available."}
            </div>
        </div>
    );
}
